import React from 'react';
import { FieldError, UseFormRegisterReturn } from 'react-hook-form';

interface TextAreaFieldProps {
  label?: string;
  placeholder: string;
  register: UseFormRegisterReturn;
  error?: FieldError;
  rows?: number;
  defaultValue?:string
}

const TextAreaField: React.FC<TextAreaFieldProps> = ({ label, placeholder, register, error,defaultValue, rows = 5 }) => {
  return (
    <div className="mb-4 w-full">
      {label && (
         <label className="block text-sm font-semibold text-Black mb-2 capitalize">
          {label}
        </label>
      )}
      <textarea
        placeholder={placeholder}
        defaultValue={defaultValue}
        rows={rows}
        {...register}
        className={`w-full p-3 rounded-[8px] border resize-none ${
          error ? 'border-danger' : 'border-LightGrey3'
        } focus:outline-none focus:ring-2 focus:ring-primary  placeholder:text-sm`}
      />
      {error && <span className="text-danger text-sm mt-1 block">{error.message}</span>}
    </div>
  );
};

export default TextAreaField;
